import type { ThemeDefinition } from "./types";
import { GRUVBOX, hexToSrgb, hexToLinear } from "./palette";

export const gruvbox: ThemeDefinition = {
  label: "Gruvbox",
  className: "theme-gruvbox",
  bg: GRUVBOX.bg,
  text: GRUVBOX.fg,
  textMuted: GRUVBOX.fgMuted,
  accent: GRUVBOX.accent,
  glassRgb: GRUVBOX.glassRgb,
  border: GRUVBOX.border,
  borderHighlight: GRUVBOX.borderHighlight,
  separator: GRUVBOX.separator,
  selection: GRUVBOX.selection,
  selectionText: GRUVBOX.selectionText,
  gridColor: GRUVBOX.fg,
  noiseOpacity: GRUVBOX.noiseOpacity,
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.45)",
  gpuClear: hexToSrgb(GRUVBOX.bg),
  gpuGridLine: hexToLinear(GRUVBOX.fg),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear(GRUVBOX.accent),
  gpuAxisZ: hexToLinear(GRUVBOX.aqua),
  axisXColor: GRUVBOX.accent,
  axisZColor: GRUVBOX.aqua,
  font: '"JetBrains Mono", monospace',
  fontImport: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@300;400;500;600;700&display=swap',
};
